import Tabs from './components/tabs'

$(document).ready(function () {

  if($('.multitab').length > 0) {
    new Tabs();
  }

});